// Android : Tone.js construit son contexte avec latencyHint 'interactive', soit
// le buffer le plus court que le navigateur accepte. Mesure sur Galaxy A50
// (Exynos 9610, Android 11) : baseLatency 4 ms. Le WebView n'arrive pas a
// alimenter la sortie a ce rythme, Chrome logue
// "SyncReader::Read timed out, audio glitch count=..." en continu et le son
// crachotte en permanence, alors que le process ne consomme que 24 % de CPU :
// c'est le delai imparti qui est trop court, pas la puissance qui manque.
//
// On demande donc un buffer plus large, sur Android UNIQUEMENT. iOS et le web
// ne construisent aucun contexte ici et gardent exactement le comportement
// d'avant. Le decalage ajoute est repris par androidLatencyCompensation, qui
// remesure baseLatency + outputLatency apres Tone.start() et recale la sync MIDI.
//
// Applique a l'import, comme nativeAudioFetch et pour la meme raison : le
// singleton audioEngine construit des noeuds Tone des la phase d'import (son
// constructeur prechauffe la banque de samples). Un setContext pose apres les
// laisserait accroches a l'ancien contexte, donc muets.
//
// PIEGE, verifie sur appareil : Tone expose `Transport` et `Destination` comme
// des constantes evaluees a l'import (`export const Transport =
// getContext().transport`). Elles restent donc accrochees au contexte d'origine,
// que ce module remplace et libere : les progressions ne demarraient plus. Tout
// le code de l'app passe par Tone.getTransport() / Tone.getDestination(), qui
// relisent le contexte courant a chaque appel. Ne pas revenir aux constantes.

import { Capacitor } from '@capacitor/core';
import * as Tone from 'tone';

// Secondes. Valeur numerique plutot que le mot-cle 'playback' : sa traduction
// en taille de buffer varie d'un appareil a l'autre, le nombre est reproductible.
// Mesure sur A50 : 0.04 divise les decrochages par deux sans les supprimer.
export const ANDROID_LATENCY_HINT = 0.08;

// synthPlayer pose ce lookAhead sur le contexte a son initialisation. On le
// reprend ici pour que le contexte de remplacement parte avec la meme avance de
// planification, sans dependre de l'ordre d'init.
const LOOK_AHEAD = 0.2;

let applied = false;

export const applyAndroidToneContext = () => {
  if (applied) return false;
  if (Capacitor.getPlatform() !== 'android') return false;
  applied = true;

  try {
    // L'import de Tone construit deja ses singletons (Destination, Transport),
    // ce qui cree un premier AudioContext en 'interactive'. Verifie sur
    // l'appareil : sans disposeOld il reste ouvert et compte comme un flux
    // AAudio de plus, pour rien. On le libere en posant le notre.
    const context = new Tone.Context({ latencyHint: ANDROID_LATENCY_HINT });
    context.lookAhead = LOOK_AHEAD;
    Tone.setContext(context, true);
    return true;
  } catch (error) {
    console.warn('[AndroidToneContext] setContext impossible, contexte par defaut conserve:', error);
    return false;
  }
};

applyAndroidToneContext();

export default applyAndroidToneContext;
